import { ColorSystemDefinition, colors, rgba } from "@ancon/wildcat-ui/shared";
import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";
import { FontVariant } from "../../../constants/fonts";

const Card = styled.div`
  border-radius: 16px;
  margin-top: 20px;
  box-shadow: 0px 2px 8px ${rgba(colors.black, 0.05)};
  text-align: start;
`;

const OutletName = styled.div`
  font-weight: bold;
  font-size: 20px;
  margin-top: 10px;
`;

const OrderOutletNameContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const OrderStatus = styled.div`
  border-radius: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 30px;
`;

const OrderCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 16px;
`;

const MetaContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const OrderItemCount = styled.div`
  margin-top: 10px;
  font-size: 14px;
`;

const PriceText = styled.div`
  font-weight: bold;
  font-size: 20px;
`;

const OrderDate = styled.div`
  font-size: 14px;
`;

interface OrderCardProps {
  success?: boolean;
}

export default function OrderCard({ success = false }: OrderCardProps) {
  const { watch } = useFormContext<ColorSystemDefinition>();
  const values = watch();
  const { tertiary, primary } = values;
  const { color: PrimaryColor, content: PrimaryContent } = primary;
  const { surfaces, content } = tertiary;
  const { default: DefaultContentColor } = content;
  const { default: DefaultSurface } = surfaces;
  const { success: PrimarySuccessContent, danger: PrimaryDangerContent } =
    PrimaryContent;

  return (
    <Card
      style={{
        backgroundColor: DefaultSurface.color,
      }}
    >
      <OrderCardContainer>
        <OrderOutletNameContainer>
          <OutletName
            style={{
              fontWeight: "unset",
              color: DefaultSurface.content.default,
              fontFamily: FontVariant.PrimaryBold,
            }}
          >
            Outlet Name
          </OutletName>
          <OrderStatus
            style={{
              width: 110,
              backgroundColor: success
                ? PrimarySuccessContent
                : PrimaryDangerContent,
              color: PrimaryColor,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            {success ? "Preparing" : "Cancelled"}
          </OrderStatus>
        </OrderOutletNameContainer>
        <OrderDate
          style={{
            color: DefaultSurface.content.alt_1,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          04/08/2023
        </OrderDate>
        <MetaContainer>
          <OrderItemCount
            style={{
              color: DefaultContentColor,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            2 Items
          </OrderItemCount>

          <PriceText
            style={{
              color: DefaultContentColor,
              fontFamily: FontVariant.PrimaryBold,
            }}
          >
            1,200 kr
          </PriceText>
        </MetaContainer>
      </OrderCardContainer>
    </Card>
  );
}
